export default {
  settings: {},
};
